import androidx.compose.runtime.Composable
import net.sergeych.ugdx.shared.Currency
import frontend.pages.TransferType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class TransferTypeSelectAttrsBuilder {
    var onChange: (value: TransferType?) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<TransferType> = TransferType.values().toList()

    fun onChange(handler: (value: TransferType?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
}

@Composable
fun TransferTypeSelect(
    id: String,
    selected: TransferType?,
    attrs: TransferTypeSelectAttrsBuilder.() -> Unit = {}
) {
    val builder = TransferTypeSelectAttrsBuilder()
    attrs.invoke(builder)

    Div() {
        Label(forId = id, attrs = {
            classes("block", "text-sm", "font-medium", "text-gray-700")
        }) { builder.label() }

        Select(attrs = {
            id(id)
            name("select")
            classes("mt-1", "block", "w-full", "pl-3", "pr-10", "py-2", "text-base", "border-gray-300", "focus:outline-none", "focus:ring-indigo-500", "focus:border-indigo-500", "sm:text-sm", "rounded-md")
            onChange {
                val id = it.value
                val type = builder.options.find { it.toString() == id }
                builder.onChange(type)
            }
        }) {
            builder.options.forEach {
                val option = it

                Option(option.toString(), attrs = {
                    if (selected?.toString() == option.toString()) selected()
                }) { Text(option.label) }
            }
        }
    }
}